var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBanks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.614 1.357a.75.75 0 01.772 0l10 6A.75.75 0 0122 8.75H2a.75.75 0 01-.386-1.393l10-6zM4.708 7.25h14.584L12 2.875 4.708 7.25z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 7.25a.75.75 0 01.75.75v13a.75.75 0 01-1.5 0V8A.75.75 0 013 7.25zM7 7.25a.75.75 0 01.75.75v13a.75.75 0 01-1.5 0V8A.75.75 0 017 7.25zM17 7.25a.75.75 0 01.75.75v13a.75.75 0 01-1.5 0V8a.75.75 0 01.75-.75zM21 7.25a.75.75 0 01.75.75v13a.75.75 0 01-1.5 0V8a.75.75 0 01.75-.75zM9.25 15.98a2.75 2.75 0 115.5 0v5a.75.75 0 01-.75.75h-4a.75.75 0 01-.75-.75v-5zM12 14.73c-.69 0-1.25.56-1.25 1.25v4.25h2.5v-4.25c0-.69-.56-1.25-1.25-1.25z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 20.98a.75.75 0 01.75-.75h20a.75.75 0 010 1.5H2a.75.75 0 01-.75-.75z",
    fill: "currentColor"
  })));
}
export default SvgBanks;